module.exports = __webpack_public_path__ + "img/AnalysisScreenShot6.6ffdf737.png";